module.exports = __webpack_public_path__ + "img/4-PVR-Attivato.1254b646.png";